<template>
  <div>
    <v-navigation-drawer
      v-model="drawerState"
      class="px-6 pt-6 overflow-y-hidden pr-2"
      id="types-drawer"
      width="550px"
      right
      fixed
      temporary
    >
      <div class="mb-5 fixed-drawer pr-8 pl-2">
        <v-row no-gutters>
          <v-col align="left">
            <h6 class="text-h6 font-weight-600 float-left text-capitalize">
              <span class="secondary--font">Column Filter</span>
            </h6>
          </v-col>
          <v-col align="right">
            <v-btn icon @click.stop="drawerState = false" class="float-right"
             v-track="'close-column-filter-drawer'">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-col>
        </v-row>
        <v-row class="mb-5">
          <v-col class="body-1">
            <span> Select the columns you want to see on the table. </span>
          </v-col>
        </v-row>
        <draggable v-bind="{ animation: 500 }" v-model="headers">
            <div v-for="(header, index) in headers" :key=index class="wrapper-row">
              <v-row>
                <v-col cols="2" class="mb-0 pb-0 d-flex justify-end">
                  <v-switch
                    color="mpBlue"
                    class="my-0 py-0"
                    v-model="header.show"
                    :disabled="header.value === 'subject' || header.value === 'contact_name'"
                  />
                </v-col>
                <v-col cols="10" class="mb-0 pb-0 pl-0 d-flex justify-space-between">
                  <span :class="{'text--disabled' : header.value === 'subject' || header.value === 'contact_name'}">
                    {{ header.text }}
                  </span>
                  <span class="multi-drag-drop-icon">
                    <span>
                      <v-icon color="grey">mdi-dots-vertical</v-icon>
                      <v-icon color="grey">mdi-dots-vertical</v-icon>
                    </span>
                  </span>
                </v-col>
              </v-row>
              <v-divider class="mt-2 mb-4" />
            </div>
        </draggable>
      </div>
      <template v-slot:append>
          <div class="pa-2">
            <v-card-actions class="px-0 d-flex align-end">
              <v-btn
                id="cancel-drawer"
                class="font-weight-bold mb-4"
                v-track="'cancel-column-filter-drawer'"
                outlined
                @click.stop="drawerState = false"
                >
                Cancel
              </v-btn>
              <v-btn
                dense
                class="font-weight-bold mb-4"
                v-track="'apply-columns-filter'"
                dark
                @click="filterColumns"
              >
                Apply
              </v-btn>
            </v-card-actions>
          </div>
        </template>
    </v-navigation-drawer>
  </div>
</template>
<script>
import draggable from 'vuedraggable'
export default {
  components: {
    draggable
  },
  props: {
    columnHeaders: {
      type: Array,
      default: []
    }
  },
  data () {
    return {
      drawerState: false,
      headers: []
    }
  },
  mounted () {
    this.headers = this.columnHeaders.filter(col => col.value!=='action')
  },
  methods: {
    filterColumns() {
      this.$emit('filterColumns', this.headers)
      this.drawerState = false
    }
  }
}
</script>

<style lang="scss" scoped>
.wrapper-row {
  cursor: grab;
}
.multi-drag-drop-icon {
  span {
    :nth-child(1){
      margin: 0px -8px 0px -16px !important;
    }
    :nth-child(2){
      margin: 0px 0px 0px -24px !important;
    }
  }
}
</style>